export const CardDefault = "bg-slate-50 dark:bg-slate-950 rounded";
